import { render, staticRenderFns } from "./header-sidebar.vue?vue&type=template&id=f266daec&scoped=true"
import script from "./header-sidebar.vue?vue&type=script&lang=js"
export * from "./header-sidebar.vue?vue&type=script&lang=js"
import style0 from "./header-sidebar.vue?vue&type=style&index=0&id=f266daec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f266daec",
  null
  
)

export default component.exports